// extracted by mini-css-extract-plugin
module.exports = {"title":"af2cf","wrapper":"f5b8a","buttons":"_3f7cd"};